// Proje zaman çizelgesi (ana sayfadaki geri sayım kartı bu tarihleri kullanır).
// Tarih değişirse sadece burayı güncelle.
export const PROJECT_START_DATE = '2025-11-03';
export const PROJECT_END_DATE = '2030-05-03';
